import styles from './index.module.scss';
import { getAssetUrl } from '@/utils/common';
import { FC, memo } from 'react';
import { useSpring, animated, easings, useTransition,useSprings } from 'react-spring';

interface BackgroundAnimateProps {
  visible: boolean;
  children?: React.ReactNode;
  opacity?: number;
  animate?: boolean;
  className?: string;
  loop?: boolean;

}

interface CircleItem {
  src: string;
  rotate: number;
  size: number;
  opacity?: number;
}

const CircleList: CircleItem[] = [
  {
    src: getAssetUrl('images/background/circle1.png'),
    rotate: 360,
    size: 1150,
    opacity: 0.5
  },
  {
    src: getAssetUrl('images/background/circle2.png'),
    rotate: -360,
    size: 3400
  },
  {
    src: getAssetUrl('images/background/circle3.png'),
    rotate: 360,
    size: 1408,
    opacity: 0.3
  },
  {
    src: getAssetUrl('images/background/circle1.png'),
    rotate: -360,
    size: 2766,
    opacity: 0.2
  },
  {
    src: getAssetUrl('images/background/circle3.png'),
    rotate: 360,
    size: 3163,
    opacity: 0.2
  },
];

const BackgroundAnimate: FC<BackgroundAnimateProps> = (
  { 
    children, 
    visible,
    opacity,
    animate = true,
    className,
    loop = false,
  }
) => {
  const containerAnimate = useSpring({
    opacity: visible ? 1 : 0,
    config: {
      duration: 500,
    },
  });

  let duration = 0;
  if(animate){
    duration = 3000;
    if(loop){
      duration = 1000;
    }
  }
  

  const transitions = useTransition(visible ? CircleList : [], {
    from: {
      scale: 0,
      rotate: 0,
      opacity: 0,
    },
    enter: (item: CircleItem) => ({
      scale: 1,
      rotate: item.rotate,
      // opacity: opacity ?? item.opacity ?? 1,
      opacity:  item.opacity ?? 1,
    }),
    leave: {
      scale: 0,
      rotate: 0,
      opacity: 0,
    },
    config: {
      easing: easings.easeOutCirc,
      duration: duration,
    },
    // keys: (item: CircleItem) => item.src,
  });

  const [loopSprings] = useSprings(CircleList.length, i => ({
    from: {
      rotate: 0,
    },
    to: {
      rotate: CircleList[i].rotate,
    },
    loop: loop && visible,
    config: { duration: 40 * 1000, easing: easings.linear },
  }));
  

  return (
    <animated.div 
      className={`${styles.backgroundAnimate} ${className}`} 
      style={{
        ...containerAnimate,
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      <img 
        src={getAssetUrl('images/background/bg.png')} 
        alt="background"
        style={{
          opacity: opacity ?? 0.8,
        }}
      />

      {transitions((style, item, _, index) => {
        if(loop){
          style.rotate = loopSprings[index].rotate;
        }
        return (
          <animated.img 
            key={item.src}
            src={item.src} 
            alt={`circle${index + 1}`} 
            className={styles.circle}
            style={{
              ...style,
              width: item.size,
              height: item.size,
              left: `calc(50% - ${item.size / 2}px)`,
              top: `calc(50% - ${item.size / 2}px)`,
            }}
          />
        )
      })}

      <div className={styles.content}>
        {children}
      </div>
    </animated.div>
  )
}

export default memo(BackgroundAnimate);
